var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar__container"},[_c('div',{staticClass:"bar__title",class:{ 'bar__title--show': _vm.showTitle }},[_vm._t("default")],2),_c('div',{staticClass:"bar",style:({
      height: `${_vm.height}px`,
      width: _vm.max ? `${(_vm.itemMax / _vm.max) * 100}%` : '100%',
    })},[_vm._l((_vm.shownItems),function(item,idx){return _c('div',{key:item.label,staticClass:"bar__segment",class:{ [`background-${item.color}`]: item.color },style:({
        width: `${(item.value / _vm.itemMax) * 100}%`,
      })},[(idx === _vm.shownItems.length - 1)?_vm._t("double"):_vm._e()],2)}),_vm._t("misc")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }